// extracted by mini-css-extract-plugin
export default {"grey900":"#212121","grid":"IconShuffle_grid__shaac","icon":"IconShuffle_icon__t8DDf"};